<template>
  <div class="content">
    <header
      class="header"
      v-if="!hideTopBar && data.cities && data.cities.length"
    >
      <div class="top-bar">
        <div class="top-bar-theater">
          <div class="form-group-select" v-if="!hideTheaterSelector">
            <SelectCities
              :options="data.cities.map((city) => city.name)"
              :default="cityDefault"
              class="select"
              @click="cityChange"
              :disabled="isCityIdInParams"
            />
          </div>
          <div v-if="!hideTheaterSelector && selectCity && theatreList.length">
            <div class="form-group-select">
              <SelectCities
                :options="theatreList.map((theater) => theater.Name)"
                :default="theaterDefault"
                class="select"
                @click="cityTheaterChange"
                :key="theaterDefault"
              />
            </div>
          </div>
        </div>
        <div class="form-group-date">
          <div @click="handleTimePanel" class="date">{{ dateFormat }}</div>
          <div class="date-picker" v-if="showTimePanel">
            <DatePicker
              name="selectDate"
              v-model="data.scheduleForm.selectDate"
              format="YYYY-MM-DD"
              type="date"
              placeholder="Дата"
              @change="changeDate"
              :disabled-date="disabledBeforeTodayAndAfterAWeek"
              lang="ru"
              inline
            />
          </div>
        </div>
      </div>
    </header>
    <section>
      <Movie
        v-for="movie in getFilmBySelectDayAndTheatreId"
        :movie="movie"
        :key="movie.id"
        :cityId="selectCity"
        :date="date"
      />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Movie from './Movie/Movie';
import SelectCities from './SelectCities';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import { types } from '@/types';

export default {
  name: 'GeneralSchedule',
  components: { Movie, DatePicker, SelectCities },

  data() {
    return {
      date: new Date(),
      movies: [],
      selectCity: null,
      selectDate: null,
      theatreId: null,
      showTimePanel: false,
      isOpenSelectCity: false,
      formats: [],
      otherFormats: [],
      isOpenSelectAllFormats: false,
      theatreList: [{ Name: 'Все площадки' }],
      theatresFromQuery: [],
      isCityIdInParams: false,
      crmSystemId: null,
      hideTheaterSelector: false,
      hideTopBar: false,
    };
  },
  created() {
    console.log(this.$route.query.theatres, 'created');
  },
  mounted() {
    console.log(this.$route.query.theatres, 'mounted');

    this.$store.commit('SET_START_FROM_SCHEDULE');

    if (this.$route.params.cityId || this.$route.query.cityId) {
      this.isCityIdInParams = true;
    }

    this.selectCity = this.$route.params.cityId || this.$route.query.cityId;

    this.theatreId =
      this.$route.params.theatreId || this.$route.query.theatreId;

    const dataUnmount = this.data.afterUnmountedGeneralSchedule;
    this.theatresFromQuery =
      dataUnmount && dataUnmount.theatres
        ? dataUnmount.theatres
        : this.$route.query.theatres
        ? this.$route.query.theatres.split(',')
        : [];
    this.crmSystemId = dataUnmount
      ? dataUnmount.crmSystemId
      : this.$route.query.crmSystemId;

    if (this.user.sessionId) this.loadPage();

    if (this.data.cities) {
      this.theatreList = this.theatreList.concat(this.getTheatreList);
    }

    if (this.$route.query.date) {
      try {
        const date = new Date(this.$route.query.date);
        if (!isNaN(date)) {
          const selectedDate = new Date(date.setHours(0, 0, 0, 0));
          this.data.scheduleForm.selectDate = selectedDate;
        }
      } catch (e) {
        console.log(e);
      }
    }

    if (this.$route.query.hideTheaterSelector === 'true') {
      this.hideTheaterSelector = true;
    }

    if (this.$route.query.hideTopBar === 'true') {
      this.hideTopBar = true;
    }
  },
  computed: {
    ...mapState(['data', 'user', 'loading']),

    cityDefault: function () {
      const cityId =
        this.selectCity ||
        this.$route.params.cityId ||
        this.$route.query.cityId;
      const city = this.data.cities.filter((city) => {
        if (city.id === cityId) {
          return city;
        }
      });
      if (city.length !== 0) {
        return city[0].name;
      }
      return this.data.cities[0].name;
    },

    theaterDefault: function () {
      const theatreId =
        this.$route.params.theatreId || this.$route.query.theatreId;

      const theater = this.theatreList.filter((theater) => {
        if (theater.Id === theatreId) {
          return theater;
        }
      });
      if (theater.length > 0) {
        return theater[0].Name;
      }
      return 'Выберите кинотеатр';
    },

    getTheatreList: function () {
      const currentCity = this.selectCity || this.$route.params.cityId;

      if (this.data.cities.find((city) => city.id === currentCity)) {
        const theatres = this.data.cities.find(
          (city) => city.id === currentCity,
        ).Theatres;
        return this.theatresFromQuery.length
          ? theatres.filter((theatre) =>
              this.theatresFromQuery.includes(theatre.Id),
            )
          : theatres || [];
      }

      return [];
    },

    dateFormat() {
      const date = new Date(this.data.scheduleForm.selectDate);
      return [
        new Date(date).getDate() < 10
          ? '0' + new Date(date).getDate()
          : new Date(date).getDate(),
        new Date(date).getMonth() + 1 < 10
          ? '0' + (new Date(date).getMonth() + 1)
          : new Date(date).getMonth() + 1,
        new Date(date).getFullYear(),
      ].join('.');
    },

    cityNamesFormQuery() {
      const cityNames = this.theatresFromQuery.map((theatreId) => {
        return this.getTheatreList.find((theatre) => theatre.Id === theatreId)
          .Name;
      });
      return cityNames.join(', ');
    },

    getFilmBySelectDayAndTheatreId() {
      if (this.data.schedule) {
        const selectedDate = this.data.scheduleForm.selectDate;

        let filmsByDay = this.data.schedule.find((filmsWithData) => {
          const filmDate = new Date(
            new Date(filmsWithData.Date).getFullYear(),
            new Date(filmsWithData.Date).getMonth(),
            new Date(filmsWithData.Date).getDate(),
          );
          const selectDate = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate(),
          );

          return filmDate.getTime() === selectDate.getTime();
        });

        if (
          (this.theatreId ||
            this.theatresFromQuery.length ||
            this.crmSystemId) &&
          filmsByDay &&
          filmsByDay
        ) {
          const theatreListId = this.getTheatreList.map(
            (theatre) => theatre.Id,
          );
          filmsByDay = {
            ...filmsByDay,
            Films: filmsByDay.Films.map((film) => ({
              ...film,
              Theatres: film.Theatres.filter((theatre) => {
                if (this.theatreId) {
                  return this.theatreId === theatre.Id;
                }
                return theatreListId.includes(theatre.Id);
              }),
            })),
          };
        }

        const films = filmsByDay
          ? filmsByDay.Films.filter((film) => film.Theatres.length > 0)
          : [];

        return filmsByDay && films.length > 0 ? films : [];
      }

      return [];
    },
  },
  methods: {
    changeDate() {
      this.showTimePanel = false;

      const date = new Date(this.data.scheduleForm.selectDate);
      const formattedDate = [
        date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1,
        date.getFullYear(),
      ].join('.');

      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          date: formattedDate,
        },
      });
    },
    handleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    cityChange(e) {
      const cities = this.data.cities.map((city) => city.name).indexOf(e);
      const cityId = this.data.cities[cities].id;
      this.selectCity = cityId;
      this.$store.dispatch('getSchedule', cityId);
      this.$router.push(`/generalSchedule/${cityId}`);
      const btnAll = [{ Name: 'Все площадки' }];
      this.theatreList = btnAll.concat(this.getTheatreList);
      this.theatreId = this.$route.params.theatreId;
    },

    cityTheaterChange(e) {
      const theatersIndex = this.theatreList
        .map((thetre) => thetre.Name)
        .indexOf(e);

      if (theatersIndex === 0) {
        this.theatreId = null;
        if (this.crmSystemId) {
          this.$router.push(
            `/generalSchedule/${this.selectCity}?crmSystemId=${this.crmSystemId}`,
          );
        } else if (this.theatresFromQuery.length) {
          this.$router.push(
            `/generalSchedule/${this.selectCity}?theatres=${this.theatresFromQuery}`,
          );
        } else {
          this.$router.push(`/generalSchedule/${this.selectCity}`);
        }
      } else {
        const theaterId = this.theatreList[theatersIndex].Id;
        this.theatreId = theaterId;
        this.$router.push(`/generalSchedule/${this.selectCity}/${theaterId}`);
      }
    },

    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let schedule = this.data.schedule;

      if (this.theatresFromQuery.length !== 0) {
        schedule = this.data.schedule.filter((item) =>
          item.Films.find((film) =>
            film.Theatres.find((theatre) =>
              this.theatresFromQuery.includes(theatre.Id),
            ),
          ),
        );
      }

      const dates = schedule.map((item) => Number(new Date(item.Date)));

      const filmsCurrentTheatre = schedule
        .filter(
          (day) =>
            day.Films.filter(
              (film) =>
                film.Theatres.filter((theatre) => theatre.Id === this.theatreId)
                  .length > 0,
            ).length > 0,
        )
        .map((day) => +new Date(day.Date));

      return (
        date < today ||
        !dates.includes(Number(new Date(date))) ||
        (this.theatreId &&
          !filmsCurrentTheatre.includes(Number(new Date(date))))
      );
    },
    loadPage() {
      if (this.crmSystemId)
        this.$store.dispatch('openSchedulePage', {
          cityId: this.selectCity,
          crmSystemId: this.crmSystemId,
        });
      else this.$store.dispatch('openSchedulePage');
    },
  },
  beforeDestroy() {
    this.$store.commit(types.SET_DATA_FROM_GENERAL_SCHEDULE_BEFORE_UNMOUNTED, {
      theatreId: this.theatreId,
      theatres:
        this.theatresFromQuery.length > 0
          ? String(this.theatresFromQuery)
          : null,
      crmSystemId: this.crmSystemId,
      cityId: this.selectCity,
    });
  },
  watch: {
    'data.cities': {
      handler() {
        if (!this.$route.params.cityId && !this.$route.query.cityId) {
          this.selectCity = this.data.cities[0].id;
        }

        const request = () => {
          if (this.loading.startApp) {
            timerId = setTimeout(request.bind(this), 1);
          } else {
            this.$store.dispatch(
              'getSchedule',
              this.$route.params.cityId ||
                this.$route.query.cityId ||
                this.data.cities[0].id,
            );
            clearTimeout(timerId);
          }
        };

        let timerId = setTimeout(request.bind(this), 0);

        if (
          this.selectCity ||
          this.$route.params.cityId ||
          this.$route.query.cityId
        ) {
          this.theatreId =
            this.$route.params.theatreId || this.$route.query.theatreId;
          this.theatreList = this.theatreList.concat(this.getTheatreList);
        }
      },
    },

    'user.sessionId': {
      handler() {
        this.loadPage();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  min-height: 100vh;
  background: #212227;
}

.cities-from-queries {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-size: 30px;
  line-height: 35px;
  color: #ffffff;
  margin-top: 1rem;
}

.form-group-select {
  position: relative;

  select {
    appearance: none;
    background-color: transparent;
    border: none;
    padding: 0 1em 0 0;
    margin: 0;
    width: 240px;
    cursor: inherit;
    outline: none;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-size: 30px;
    line-height: 35px;
    text-decoration-line: underline;
    color: #ffffff;
    position: relative;
    top: -4px;

    option {
      font-size: 12px;
      line-height: 14px;
      min-height: 12px;
      color: #000;
    }

    &::-ms-expand {
      display: none;
    }
  }
}

.form-group-date {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 35px;
  color: #ffffff;
  position: relative;
  margin-left: auto;
}

.date {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #fff;
  padding-right: 0.75rem;
  margin-right: 1.5rem;
  cursor: pointer;
  position: relative;

  &:after {
    position: absolute;
    display: block;
    content: '';
    width: 24px;
    height: 24px;
    background: url('../../assets/calendar.png') no-repeat center;
    top: 50%;
    transform: translateY(-50%);
    right: -24px;
  }
}

.header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: #24262ce6;
  padding: 1rem 2rem;
}

.row {
  display: flex;
  align-items: center;
  background: #212227;
  justify-content: flex-start;
}

.date-picker {
  position: absolute;
  left: -7rem;
  top: 2rem;
}

.top-bar {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  gap: 1rem;
}

.top-bar-theater {
  flex: 1;
}
</style>
